import { toast } from "react-toastify";

//CONSTANT
import { STRING } from ".";

export function SHOW_TOAST(message, type, visibilityTime) {
  switch (type) {
    case "success":
      toast.success(message, {
        position: "top-right",
        autoClose: visibilityTime || 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 10000 },
      });
      break;

    case "info":
      toast.info(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 10000 },
      });
      break;

    case "warning":
      toast.warn(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 10000 },
      });
      break;
    case "error":
      toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 10000 },
      });
      break;

    default:
      toast(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: { zIndex: 10000 },
      });
      break;
  }
}

export function detectOS() {
  // Check if the browser supports navigator.userAgentData (modern approach)
  if (navigator.userAgentData) {
    const platforms = navigator.userAgentData.platform || navigator.userAgentData.mobile;
    if (platforms.indexOf("Windows") !== -1) return "Windows";
    if (platforms.indexOf("macOS") !== -1) return "Mac OS";
    if (platforms.indexOf("Linux") !== -1) return "Linux";
    if (platforms.indexOf("iOS") !== -1) return "iOS";
    if (platforms.indexOf("Android") !== -1) return "Android";
    if (platforms.indexOf("iPad") !== -1) return "iPad";
    return "Unknown";
  }

  // Fallback for older browsers using navigator.userAgent
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows/i.test(userAgent)) return "Windows";
  if (/macintosh|mac os x/i.test(userAgent)) return "Mac OS";
  if (/linux/i.test(userAgent)) return "Linux";
  if (/iphone/i.test(userAgent)) return "iOS";
  if (/android/i.test(userAgent)) return "Android";
  if (/ipad/i.test(userAgent)) return "iPad";

  return "Unknown";
}

// hexToRgba now lives in @learnzapp/core/theme as rgbaString (same output,
// plus input validation); re-exported under the old name for existing callers.
export { rgbaString as hexToRgba } from "@learnzapp/core/theme";

export const QUESTION_PRIORITY = [
  { title: "Questions I answered incorrectly", key: STRING.incorrect_tag },
  { title: "Questions I have not yet answered", key: STRING.unanswered },
  { title: "Questions I bookmarked", key: STRING.bookmark },
  { title: "Default (App's Smart Logic)", key: STRING.default },
];



export const DEFAULT_CURRENCY = {
  country: "US",
  countryCode: "usd",
  symbol: "$",
  name: "United States dollar",
};

export const getDateFromMilliseconds = (milliseconds) => {
  // Ensure that input is a number
  if (typeof milliseconds !== "number") {
    throw new Error("Input must be a number representing milliseconds.");
  }

  // Create a new Date object using the milliseconds
  const date = new Date(milliseconds);

  // Extract the day, month, and year
  const day = String(date.getDate()).padStart(2, "0");
  const monthNumber = date.getMonth(); // January is 0!
  const year = date.getFullYear();

  // Array of month abbreviations
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const month = months[monthNumber];

  // Format the date string
  const dateString = `${month} ${day}, ${year}`;

  return dateString;
};

export const formatTime = (seconds) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
  const mDisplay = m > 0 ? m + (m === 1 ? " minute, " : " minutes, ") : "";
  const sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";
  return hDisplay + mDisplay + sDisplay;
};

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const CLOULD_FUNCTION_URL =
  "https://us-central1-lsat-b6833.cloudfunctions.net/convertQuestionScores?docPath=/apps/APP_NAME/users/USER_ID";
export const SEND_MAIL_FUNCTION =
  "https://www.learnzapp.com/php/sendRedemptionEmail.php?access_code=ACCESS_CODE&expiration_date=EX_DATE&user_email=USER_EMAIL&user_name=USER_NAME&app_name=APP_NAME&is_subscription=IS_SUBSCRIPTION&redeemed_by=REDEEMED_BY";
